import { Theme } from "./Theme";
import styled, { keyframes } from "styled-components";
import { Logo } from "./Logo";

type AnimatedLogoPropsType = {
  height: string;
  className?: string;
};

export function AnimatedLogo({ height, className }: AnimatedLogoPropsType) {
  return (
    <ShowAnimatedLogo className={className}>
      <Logo height={height} />
    </ShowAnimatedLogo>
  );
}

const logoBreath = keyframes`
  0% {
    transform: translateY(0) scale(1);
    filter: drop-shadow(0 0 0 rgba(${Theme.colors.accentRgb}, 0));
  }

  50% {
    transform: translateY(-2px) scale(1.045);
    filter: drop-shadow(0 10px 26px rgba(${Theme.colors.accentRgb}, 0.18));
  }

  100% {
    transform: translateY(0) scale(1);
    filter: drop-shadow(0 0 0 rgba(${Theme.colors.accentRgb}, 0));
  }
`;

const ShowAnimatedLogo = styled.div`
  display: inline-block;
  width: fit-content;
  height: fit-content;
  position: relative;
  transform-origin: center;
  animation: ${logoBreath} 3.4s ease-in-out infinite;
  will-change: transform, filter;
`;



